import { ReactNode } from 'react';
import CampaignLayout from '~/layouts/CampaignLayout';
import DefaultLayout from '~/layouts/DefaultLayout';
import { CampaignProps } from '~/types/Campaign';
import { CampaignProvider } from './CampaignContext';

type LayoutWrapperProps = {
  children: ReactNode;
  breadcrumbsComponent?: ReactNode;
  campaign: CampaignProps | undefined;
  state?: 'default' | 'large';
  isSearchPage?: boolean;
  consentNeeded?: boolean;
};

function LayoutWrapper({
  children,
  breadcrumbsComponent,
  campaign,
  state,
  isSearchPage,
  consentNeeded = true
}: LayoutWrapperProps) {
  if (campaign) {
    return campaign.isInternal ? (
      <CampaignProvider campaign={campaign}>
        <DefaultLayout 
          state={state} 
          breadcrumbs={breadcrumbsComponent} 
          consentNeeded={consentNeeded}
        >
          {children}
        </DefaultLayout>
      </CampaignProvider>
    ) : (
      <CampaignProvider campaign={campaign}>
        <CampaignLayout
          campaign={campaign}
          breadcrumbs={breadcrumbsComponent}
          isSearchPage={isSearchPage}
        >
          {children}
        </CampaignLayout>
      </CampaignProvider>
    );
  }

  return (
    <DefaultLayout 
      state={state} 
      breadcrumbs={breadcrumbsComponent} 
      consentNeeded={consentNeeded}
    >
      {children}
    </DefaultLayout>
  );
}

export default LayoutWrapper;
